import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { QuillModule } from 'ngx-quill';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { ToastyModule } from 'ng2-toasty';
import { TimezoneConverterPipe, TimezoneDatePipe } from './pipes/timezone.pipe';
// import { DomSanitizer } from '@angular/platform-browser';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {NzModalModule} from 'ng-zorro-antd/modal';
import { TaigaChapterDropzoneComponent } from './components/taiga-chapter-dropzone/taiga-chapter-dropzone.component';
import { TaigaUiSharedModule } from './taiga/taiga-ui-shared.module';

@NgModule({
    exports: [
        TaigaChapterDropzoneComponent,
        TaigaUiSharedModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NzIconModule,
        PerfectScrollbarModule,
        SearchPipe,
        NzTableModule,
        NzSelectModule,
        NzDatePickerModule,
        NzUploadModule,
        ReactiveFormsModule,
        NzTabsModule,
        NzGridModule,
        NzFormModule,
        NzCollapseModule,
        NzRadioModule,
        AngularEditorModule,
        QuillModule,
        NzNotificationModule,
        ToastyModule,
        TimezoneConverterPipe,
        ScrollingModule, 
        InfiniteScrollModule,
        TimezoneDatePipe,
        
    ],
    imports: [
        RouterModule,
        CommonModule,
        NzIconModule,
        NzToolTipModule,
        PerfectScrollbarModule,
        ReactiveFormsModule,
        TaigaUiSharedModule,
    ],
    declarations: [
        SearchPipe,
        TimezoneConverterPipe,
        TimezoneDatePipe,
        TaigaChapterDropzoneComponent
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
